import { UI } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, HStack, VStack } from 'native-base';
import React from 'react';

import { ItemDetailsComponentProps } from '../..';

export const PublicOfferDetailsHeader: React.FC<ItemDetailsComponentProps> = ({
  onClose,
  offer,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <VStack>
        <HStack justifyContent="space-between">
          <UI.Text color="neutral.dark">Detalhes da operação</UI.Text>
          <UI.IconButton
            testId={'icon-close'}
            icon="CloseModal"
            iconSize="xs"
            borderWidth={{ base: 0, lg: '1px' }}
            variant="rounded"
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            borderColor={Color['brand.primary.principal']}
            onPress={onClose}
            p={0}
          />
        </HStack>
        <UI.Heading
          testId="direct-treasury-title"
          size="h4"
          fontSize={Typography['fontsize.display']}>
          {offer.offerName}
        </UI.Heading>
      </VStack>
      <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
    </VStack>
  );
};
